import { http } from "./http";
import type { BoardResponse, BoardVoteResponse } from "../types/feedback";

// The in-app feedback form and the public feedback board built on it.
export const feedbackApi = {
  send: (body: Record<string, unknown>) => http.post<unknown>("/feedback", body),
  uploadPhoto: (file: FormData) => http.post<{ url?: string }>("/feedback/photo", file),
  board: () => http.get<BoardResponse>("/feedback/board"),
  vote: (id: string) => http.post<BoardVoteResponse>(`/feedback/${encodeURIComponent(id)}/vote`),
  report: (id: string) => http.post<unknown>(`/feedback/${encodeURIComponent(id)}/report`),
};
